import {GRANITE_3} from '@gaia/colors';
import {ListItemButton, ListItemButtonProps, ListItemIcon, ListItemText} from '@mui/material';
import {forwardRef} from 'react';

interface ActionMenuButtonProps extends ListItemButtonProps {
    onClick: () => void;
    icon: JSX.Element;
    label: string;
    href?: string;
    dense?: boolean;
    children?: React.ReactNode;
}

export default forwardRef(function ActionMenuButton(
    {onClick, icon, label, href, dense, children, ...listItemProps}: ActionMenuButtonProps,
    ref?: React.Ref<HTMLDivElement>
) {
    return (
        <ListItemButton
            ref={ref}
            onClick={onClick}
            {...(href && {
                component: 'a',
                href,
                target: '_blank',
            })}
            sx={(theme) => ({padding: theme.spacing(1, 2)})}
            {...listItemProps}
        >
            <ListItemIcon
                sx={(theme) => ({
                    marginRight: theme.spacing(dense ? 0.5 : 4),
                    color: GRANITE_3,
                })}
            >
                {icon}
            </ListItemIcon>
            <ListItemText primary={label} primaryTypographyProps={{sx: {fontSize: 14}}} />
            {children}
        </ListItemButton>
    );
});
